import script from "./SecondaryVaccinationPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SecondaryVaccinationPage.vue?vue&type=script&setup=true&lang=js"

import "./SecondaryVaccinationPage.vue?vue&type=style&index=0&id=2b828438&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b828438"]])

export default __exports__